<section class="site-getStarted-main-wrap" appIntersectionObserver>
    <div class="container">
        <div class="site-getStarted-main">
            <div class="site-common-heading hidden delay-1">
                <h2 class="site-heading-h2">Ready to <span>Get Your Report</span></h2>
            </div>
            <div class="site-getStarted-content hidden delay-2">
                <h4 class="site-heading-h4">Select the service you need and order your report today.</h4>
            </div>
            <!-- <app-info-boxes /> -->
            <div class="site-getStarted-main-wrap site-service-box-main-wrap">
                <div class="container">
                    <div class="site-getStarted-main">
                        <div class="site-getStarted-content-columns">
                            <div class="site-getStarted-column hidden delay-3">
                                <div class="site-getStarted-content-column-inner">
                                    <div class="site-getStarted-column-img">
                                        <img _ngcontent-ng-c57721346="" src="images/svg/deep-social-meadi-report.svg"
                                            alt="deep-social-meadi-report Image">
                                    </div>
                                    <div class="site-getStarted-column-content">
                                        <h4 class="site-heading-h4">Deep Social Media Report + Optional Add-Ons</h4>
                                        <p class="site-text-p">Start your investigation with an In-Depth Social Media
                                            Report—only
                                            $59.95.

                                            Want more? Then, enhance the report by selecting from the optional add-ons,

                                            including branding it with your company logo.
                                        </p>

                                        <div class="site-common-btn" routerLink="/order-deep-report/new">
                                            <a class="site-btn">Order Report</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="site-getStarted-column hidden delay-4">
                                <div class="site-getStarted-content-column-inner">
                                    <div class="site-getStarted-column-img">
                                        <img src="images/svg/bespoke-intelligence-report.svg"
                                            alt="bespoke-intelligence-report">
                                    </div>
                                    <div class="site-getStarted-column-content">
                                        <h4 class="site-heading-h4">Bespoke Intelligence Reports</h4>
                                        <p class="site-text-p">To support investigators with complex investigations and
                                            global asset
                                            tracing.

                                            Reports are digitally indexed with a detailed summary. You can also brand

                                            them with your company logo – Quote on request.</p>

                                        <div class="site-common-btn" routerLink="/contact-us">
                                            <a class="site-btn">Request a Quote</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="site-getStarted-column hidden delay-3">
                                <div class="site-getStarted-content-column-inner">
                                    <div class="site-getStarted-column-img">
                                        <img src="images/svg/evalution-started.svg" alt="evalution-started">
                                    </div>
                                    <div class="site-getStarted-column-content">
                                        <h4 class="site-heading-h4">Jury Vetting Reports</h4>
                                        <p class="site-text-p">Jury Selection Vetting Reports the answer to support
                                            every U.S.
                                            Attorney for their voir dire. Comprehensive background
                                            reports - only $120 per Juror or select from additional options, which can
                                            include live
                                            24/7 online monitoring during
                                            the trial.</p>

                                        <div class="site-common-btn" routerLink="/order-juror-report/new">
                                            <a class="site-btn">Order Report</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="site-getStarted-column hidden delay-4">
                                <div class="site-getStarted-content-column-inner">
                                    <div class="site-getStarted-column-img">
                                        <img src="images/svg/pre-visa-immegration.svg"
                                            alt="pre-visa-immigration-background-check">
                                    </div>
                                    <div class="site-getStarted-column-content">
                                        <h4 class="site-heading-h4">Pre-Visa / Immigration Application Due Diligence
                                        </h4>
                                        <p class="site-text-p">Avoid potential delays or refusals of a Visa and
                                            Immigration
                                            Application. Our pre-application due diligence reports aim
                                            to identify any potentially damaging information about the applicant that
                                            authorities
                                            may later uncover – only $150</p>

                                        <div class="site-common-btn" routerLink="/contact-us">
                                            <a class="site-btn">Order Report</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>